export const SCRIPT_TEMPLATE = `from playwright.sync_api import Playwright, sync_playwright, expect

def run(playwright: Playwright) -> None:
    browser = playwright.chromium.launch(headless=False)
    context = browser.new_context()

    # Open new page
    page = context.new_page()

    # Go to https://www.viavisolutions.com/en-us
    # VIAVISTEP "home"
    page.goto("https://www.viavisolutions.com/en-us")

    # Click header[role="banner"] >> text=Products and Services
    page.locator("header[role=\"banner\"] >> text=Products and Services").click()

    # Click text=Network Test and Certification >> nth=1
    page.locator("text=Network Test and Certification").nth(1).click()

    # Click header[role="banner"] >> text=Ethernet Test >> nth=0
    page.locator("header[role=\"banner\"] >> text=Ethernet Test").first.click()
    # VIAVISTEP "products"
    page.wait_for_url("https://www.viavisolutions.com/en-us/products/ethernet-test")

    # ---------------------
    context.close()
    browser.close()


with sync_playwright() as playwright:
    run(playwright)

`;
